import { render } from "./RestaurantMenu.vue?vue&type=template&id=25e3a3bd&scoped=true"
import script from "./RestaurantMenu.vue?vue&type=script&lang=js"
export * from "./RestaurantMenu.vue?vue&type=script&lang=js"

import "./RestaurantMenu.vue?vue&type=style&index=0&id=25e3a3bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e3a3bd"]])

export default __exports__